export default {
    state: {
        clientes: [],
    },
    getters: {
        clientes: state => state.clientes || [],
    },
    mutations: {
        SET_CLIENTES: (state, payload) => state.clientes = payload,
    },
    actions: {
        refresh_clientes({commit}, payload) {
            commit('SET_CLIENTES', payload)
        }
    }
}